import { CheckCircle2 } from 'lucide-react';

/** Telas finais do checkout: aguardando análise, já inscrita, PIX gerado e pago. */
export default function CheckoutSucesso({
  paymentResult,
  valorExibicao,
  formattedTime,
  copiarPixCopiaECola,
  pixCopiado,
  onInicio,
  onCancelar,
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-4 font-sans text-slate-900">
      {paymentResult?.pendingApproval ? (
        <div className="space-y-5 py-6 max-w-lg mx-auto">
          <div className="w-16 h-16 mx-auto rounded-full bg-pink-100 flex items-center justify-center">
            <span className="text-3xl">📋</span>
          </div>
          <h3 className="text-2xl font-black text-slate-900 uppercase">
            Inscrição recebida!
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed max-w-sm mx-auto">
            Seu comprovante foi enviado para análise. Assim que aprovado, você
            receberá um <strong>email com o link de pagamento</strong>.
          </p>
          <div className="bg-pink-50 border border-pink-100 rounded-2xl p-4 text-sm text-slate-600">
            Fique de olho no email informado. Qualquer dúvida, entre em contato
            pelo WhatsApp.
          </div>
          <button
            type="button"
            onClick={() => onInicio()}
            className="w-full py-3.5 px-6 bg-[#ff2d6c] text-white font-black rounded-full text-xs uppercase tracking-widest"
          >
            Voltar ao início
          </button>
        </div>
      ) : paymentResult?.alreadyRegistered &&
        paymentResult?.status === 'CONFIRMED' ? (
        <div className="space-y-5 py-6 max-w-lg mx-auto">
          <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center">
            <CheckCircle2 size={32} className="text-amber-600" />
          </div>

          <h3 className="text-2xl font-black text-slate-900 uppercase">
            Você já está inscrita neste evento
          </h3>

          <p className="text-sm text-slate-500 leading-relaxed">
            Identificamos que já existe uma inscrição vinculada ao CPF informado
            para este encontro.
          </p>

          {paymentResult?.horario && (
            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                Horário reservado
              </p>

              <p className="mt-2 text-lg font-black text-slate-900">
                {paymentResult.horario}
              </p>
            </div>
          )}

          <div className="bg-[#fff5f7] border border-pink-100 rounded-2xl p-4 text-sm text-slate-600">
            Caso tenha dúvidas ou acredite que isso seja um erro, entre em
            contato com nossa equipe pelo WhatsApp.
          </div>

          <button
            type="button"
            onClick={() => onInicio()}
            className="w-full py-3.5 px-6 bg-[#ff2d6c] text-white font-black rounded-full text-xs uppercase tracking-widest"
          >
            Voltar ao início
          </button>
        </div>
      ) : paymentResult?.pixQrCode || paymentResult?.pixCopiaECola ? (
        <>
          <h2 className="text-xl font-[1000] text-slate-900 tracking-tight">
            Total a pagar: R$ {valorExibicao}
          </h2>
          <div className="my-6 p-2 bg-white border border-slate-100 rounded-2xl shadow-sm">
            <img
              src={paymentResult.pixQrCode}
              alt="QR Code Pix"
              width={220}
              height={220}
              className="object-contain"
            />
          </div>
          <h3 className="text-lg font-black text-slate-900 tracking-tight uppercase">
            Escaneie ou copie o código para pagar
          </h3>
          <p className="mt-2 text-sm text-slate-400 font-medium max-w-sm leading-relaxed">
            Abra o aplicativo de seu banco e efetue o pagamento na opção "Pix
            Copia e Cola" ou aponte a câmera para o QR Code acima.
          </p>
          <div className="my-5 space-y-0.5">
            <p className="text-sm font-extrabold text-slate-800">
              Não feche nem atualize esta tela.
            </p>
            <p className="text-sm text-slate-500 font-bold">
              Tempo restante:{' '}
              <span className="font-black text-slate-900">{formattedTime}</span>
            </p>
          </div>
          <div className="w-full space-y-3 max-w-sm mt-2">
            <button
              type="button"
              onClick={copiarPixCopiaECola}
              className="w-full py-3.5 px-6 bg-[#fcd34d] hover:bg-[#fbbf24] text-slate-900 font-black rounded-full transition-colors text-xs uppercase tracking-widest shadow-sm cursor-pointer"
            >
              {pixCopiado === true ? '✓ Código copiado' : 'Copiar código Pix'}
            </button>

            {/* Rede de segurança: em webview de app a cópia pode ser
                  bloqueada, e sem o código à vista a leitora fica sem
                  saída — não dá para ler o próprio QR da tela com o
                  banco no mesmo celular. */}
            {pixCopiado === false && (
              <div className="rounded-2xl border border-amber-200 bg-amber-50 p-3 text-left">
                <p className="text-[11px] font-black uppercase tracking-wide text-amber-900">
                  Não foi possível copiar automaticamente
                </p>
                <p className="mt-1 text-[11px] font-semibold leading-relaxed text-amber-800">
                  Toque e segure o código abaixo para selecionar e copiar:
                </p>
                <p className="mt-2 max-h-28 overflow-y-auto break-all rounded-xl border border-amber-200 bg-white p-2.5 text-[11px] leading-relaxed text-slate-700 select-all">
                  {paymentResult.pixCopiaECola}
                </p>
              </div>
            )}
            <button
              type="button"
              onClick={() => onCancelar()}
              className="w-full py-3.5 px-6 bg-white hover:bg-slate-50 border border-slate-200 text-slate-500 font-bold rounded-full transition-colors text-xs uppercase tracking-wider cursor-pointer"
            >
              Cancelar e voltar ao início
            </button>
          </div>
        </>
      ) : (
        <div className="space-y-4 py-6">
          <CheckCircle2 size={48} className="text-[#ff2d6c] mx-auto" />
          <h3 className="text-2xl font-black text-slate-900 uppercase">
            Inscrição Efetuada com Sucesso!
          </h3>
          <p className="text-sm text-slate-500 max-w-sm mx-auto leading-relaxed">
            Seu pagamento foi confirmado! Os dados de acesso do clube e o
            cronograma foram vinculados à chave de seu CPF e enviados ao seu
            e-mail e WhatsApp.
          </p>
          <button
            type="button"
            onClick={() => onInicio()}
            className="mt-6 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold px-6 py-3 rounded-full text-xs uppercase tracking-wider cursor-pointer"
          >
            Voltar ao início
          </button>
        </div>
      )}
    </div>
  );
}
